{
  "name": "zdashboard",
  "version": "2.15.1",
  "description": "ZCode skill dashboard platform — pluggable viewers for zdesign/zview/zreview/zgoal",
  "type": "module",
  "bin": {
    "zdashboard": "./dist/cli.js"
  },
  "files": [
    "dist"
  ],
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "dev": "vite",
    "build": "tsup && vite build && node scripts/check-excalidraw-lazy.mjs",
    "build:web": "vite build",
    "build:node": "tsup",
    "start": "node dist/cli.js",
    "test": "vitest run",
    "typecheck": "tsc --noEmit",
    "test:coverage": "vitest run --coverage",
    "preview": "vite preview"
  },
  "dependencies": {
    "@excalidraw/excalidraw": "0.18.1",
    "@fontsource/vt323": "^5.3.0",
    "@phosphor-icons/react": "^2.1.10",
    "@radix-ui/react-dropdown-menu": "^2.1.24",
    "@radix-ui/react-scroll-area": "^1.2.0",
    "@radix-ui/react-separator": "^1.1.0",
    "@radix-ui/react-slot": "^1.1.0",
    "@radix-ui/react-tooltip": "^1.1.2",
    "@uidotdev/usehooks": "^2.4.0",
    "ansi-to-react": "^6.1.6",
    "class-variance-authority": "^0.7.0",
    "clsx": "^2.1.1",
    "cordis": "4.0.0-rc.8",
    "cosmokit": "^1.8.1",
    "date-fns": "^3.6.0",
    "filesize": "^11.0.0",
    "highlight.js": "^11.11.1",
    "iconv-lite": "0.7.3",
    "katex": "^0.16.11",
    "ky": "^1.7.0",
    "lodash-es": "^4.17.21",
    "lucide-react": "^0.460.0",
    "pixelarticons": "^2.4.1",
    "react": "^18.3.1",
    "react-dom": "^18.3.1",
    "react-error-boundary": "^5.0.0",
    "react-markdown": "^9.0.1",
    "rehype-autolink-headings": "^7.1.0",
    "rehype-highlight": "^7.0.1",
    "rehype-katex": "^7.0.1",
    "rehype-raw": "^7.0.0",
    "rehype-slug": "^6.0.0",
    "remark-frontmatter": "^5.0.0",
    "remark-gfm": "^4.0.0",
    "remark-math": "^6.0.0",
    "sonner": "^1.5.0",
    "tailwind-merge": "^2.5.4",
    "tsx": "^4.7.0",
    "use-debounce": "^10.0.0",
    "yaml": "^2.9.0"
  },
  "devDependencies": {
    "@tailwindcss/typography": "^0.5.20",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.2",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^22.9.0",
    "@types/react": "^18.3.12",
    "@types/react-dom": "^18.3.1",
    "@vitejs/plugin-react": "^4.7.0",
    "@vitest/coverage-v8": "1.6.0",
    "autoprefixer": "^10.4.20",
    "jsdom": "^30.0.1",
    "postcss": "^8.4.49",
    "tailwindcss": "^3.4.14",
    "tailwindcss-animate": "^1.0.7",
    "tsup": "^8.3.5",
    "typescript": "^5.6.3",
    "vite": "^5.4.10",
    "vitest": "^1.6.0"
  },
  "pnpm": {
    "onlyBuiltDependencies": [
      "esbuild"
    ]
  }
}
